import React, { useState, useEffect, useContext, useRef} from 'react';
import { useTranslation } from "react-i18next";
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { AuthContext } from "../../Header/auth - context";
import { useSelector } from 'react-redux';
import { Toast } from "primereact/toast";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { confirmDialog } from 'primereact/confirmdialog';
import { InputNumber } from 'primereact/inputnumber';
import CustomDropdown from '../../custom/customDropdown';
import { Tooltip } from 'primereact/tooltip';
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import 'primeicons/primeicons.css';

const KretanjeVozila = () => {
  const { t } = useTranslation();

    const auth = useContext(AuthContext);
    const formRef = useRef(null);
    const formRefMovement = useRef(null);
    const toast = useRef(null);
    const trip = useSelector(state => state.trip)
    const company = useSelector(state => state.company)
    const user = useSelector(state => state.user)
    const [idWorker, setIdWorker] = useState(null)
        const [selectedRowIdMovement , setSelectedRowIdMovement] = useState(null);
        const isSelected = (row) => String(getIdMovement(row)) === String(selectedRowIdMovement);
        const [vozaciNaTuriDB, setVozaciNaTuriDB] = useState(null)
        const [vozilaNaTuriDB, setVozilaNaTuriDB] = useState(null)
        const [zemljeDB, setZemljeDB] = useState(null)
        const [izabran, setIzabran] = useState(false)
        const [idMovement, setIdMovement] = useState(null)
        const [popuni, setPopuni] = useState(false)
        const [porukaTimeRange, setPorukeTimeRange] = useState(null)
        const [porukaTimeRange2, setPorukeTimeRange2] = useState(null)
        const [globalFilter, setGlobalFilter] = useState(null);
        const [first, setFirst] = useState(0);
        const [tableData, setTableData] = useState(null);
        const [allColumns, setAllColumns] = useState([]);
        const [selectedColumns, setSelectedColumns] = useState([]);
        const [originalColumnOrder, setOriginalColumnOrder] = useState([]);

    const [formSubmitted, setFormSubmitted] = useState(false);
    const [formSubmittedMovement, setFormSubmittedMovement] = useState(false);

        const getIdMovement = (row) => row?.ID ?? row?.id ?? row?.Izaberi ?? null;
        ///DATA

        const [formDataMovement, setFormDataMovement] = useState({
          id_vozilo: null,
          id_zaposleni: null,
          id_zemlja: null,
          datumOd: null,
          datumDo: null,
          ukupnoSati: null,
          dani: null,
          napomena: null
        });
        const [formDataMobilisis, setFormDataMobilisis] = useState({
          id_vozilo: null,
          id_zaposleni: null,
          datum_od: null,
          datum_do: null
        });


    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };

    const popuniRedove = async (id) => {
  
        if(!id) {
             toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste izabrali kretanje da bi popunili podatke!",
                        life: 3000,
                    });
        } else {
              let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/getMovementsDatabaseSingle", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                                if(data.message){
                                    toast.current.show({
                                    severity: "error",
                                    summary: "Error",
                                    detail: data.message,
                                    life: 3000,
                                    });
                                    return
                                }  
                         
                                popuniStavke(data)
                                
                               toast.current.show({
                                severity: "success",
                                summary: "Uspešno popunjavanje podataka kretanja!",
                                life: 3000,
                                });

                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        }
          
    }

  const popuniStavke = (apiData) => {

    setFormDataMovement({
        id_vozilo: apiData[0].id_vozilo || null,
        id_zaposleni: apiData[0].id_zaposleni || null,
        id_zemlja: apiData[0].id_zemlja || null,
        datumOd: apiData[0].datumOd ? new Date(String(apiData[0].datumOd).replace('Z', '')) : null,
        datumDo: apiData[0].datumDo ? new Date(String(apiData[0].datumDo).replace('Z', '')) : null,
        ukupnoSati: apiData[0].ukupnoSati || null,
        dani: apiData[0].ukupnoSati/24 || null,
        napomena: apiData[0].napomena || ''
      });
};

  useEffect(()=>{
    
    if(!formSubmitted){
                   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({  
                                  id: trip
                              }),
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/trip/GetTypesAndExpences", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);
                            
                                if(parsedData.PutniNalog) {
                                  
                                  setFormDataMobilisis(prev => ({ ...prev, 'datum_od': parsedData.PutniNalog[0].datumPolaska ? new Date(parsedData.PutniNalog[0].datumPolaska) : null}));
                                  setFormDataMobilisis(prev => ({ ...prev, 'datum_do': parsedData.PutniNalog[0].datumDolaska ? new Date(parsedData.PutniNalog[0].datumDolaska) : null}));
                                }

                                setZemljeDB(parsedData.ZemljeDB)
                                setVozilaNaTuriDB(parsedData.VozilaNaTuriDB)

                                if(formDataMobilisis.id_vozilo == null  && parsedData.VozilaNaTuriDB) {
                                setFormDataMobilisis(prev => ({ ...prev, ['id_vozilo']: parsedData.VozilaNaTuriDB[0].value }));
                                setFormDataMovement(prev => ({ ...prev, ['id_vozilo']: parsedData.VozilaNaTuriDB[0].value }));
                                }
                                setVozaciNaTuriDB(parsedData.VozaciNaTuriDB)

                                if(formDataMovement.id_zaposleni == null && parsedData.VozaciNaTuriDB) {
                                  setFormDataMovement(prev => ({ ...prev, ['id_zaposleni']: parsedData.VozaciNaTuriDB[0].value }));
                                  setFormDataMobilisis(prev => ({ ...prev, ['id_zaposleni']: parsedData.VozaciNaTuriDB[0].value }));
                                }
                                
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                              
    }
      },[trip,formSubmitted])

  useEffect(()=>{
        if(trip) {
  let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id_putni_nalog: trip
                            }),
                        };
                        fetch(process.env.REACT_APP_BACKEND_URL + "/trip/getMovementsDatabaseForTrip", requestOptions)
                            .then(handleErrors)
                            .then((data) => {

                            setTableData(data)

                                  if (data && data.length > 0) {
                                                const columns = Object.keys(data[0])
                                                    .filter(key => !['ID'].includes(key))
                                                    .map(key => ({
                                                    label: key,
                                                    value: key
                                                    }));
                                        
                                                 
                                                setAllColumns(columns);
                                                  const originalOrder = Object.keys(data[0]);
                                                setOriginalColumnOrder(originalOrder);
                                                
                                                // Select first 5 columns by default (or adjust as needed)
                                                setSelectedColumns(columns.slice(0, 10).map(col => col.value));
                                                }

                            })
                            .catch((error) => {
                            error.json().then((errorMessage) => {
                                toast.current.show({
                                severity: "error",
                                summary: "Error",
                                detail: errorMessage.message,
                                life: 3000,
                                });
                                console.log(errorMessage);
                            });
                            });
        } else {
            if(idWorker) {
                setIdWorker(null)
            }
            if(izabran) {
                setIzabran(false)
            }
            if(popuni) {
                setPopuni(false)
            }
        }

    },[formSubmitted,formSubmittedMovement, trip])

const resetData = ()=> {
    // Zadrži id_vozilo i id_zaposleni u objektu (i njihove vrednosti) — handleChange update-uje polja samo
    // ako je `name in formDataMovement`, pa ako reset izbaci ove ključeve, dropdown u unos-formi prestane da
    // reaguje na izbor (vrednost se ne postavlja, invalid ostaje). Čuvanjem vrednosti se i olakšava unos
    // više uzastopnih kretanja za isto vozilo/vozača.
    setFormDataMovement(prev => ({
          id_vozilo: prev.id_vozilo ?? null,
          id_zaposleni: prev.id_zaposleni ?? null,
          id_zemlja: null,
          datumOd: null,
          datumDo: null,
          ukupnoSati: null,
          dani: null,
          napomena: ''
    }))
}
const resetDataMobilisis = ()=> {
    setFormDataMobilisis({
          datum_od: null,
          datum_do: null
    })
}
const handleDeleteFuncMovement = () => {
       
            confirmDialog({
            message: "Želite obrisati kretanje?",
            acceptLabel: "Da",
            rejectLabel: "Ne",
            icon: "pi pi-info-circle",
            acceptClassName: "p-button-danger",
            accept: acceptDelete,
            reject: rejectDelete,
            });

    };

    const acceptDelete = async (id) => {
      
 setFormSubmitted(true)
  let idValue;
  if(idMovement == null && !isNaN(Number(id)))
    idValue = id
  else
    idValue = idMovement
  if (Number(idValue)) {
     let requestOptions = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + auth.token,
          },
          body: JSON.stringify({
            id: idValue
          }),
        };
        
        fetch(process.env.REACT_APP_BACKEND_URL + "/trip/deleteMovement", requestOptions)
          .then(handleErrors)
          .then((data) => {
            
             toast.current.show({
                severity: "success",
                summary: "Uspešno brisanje kretanja!",
                life: 3000,
                });
                resetData()
                resetDataMobilisis()
                setIdMovement(null)
                setFormSubmitted(false)
                setSelectedRowIdMovement(null)
          })
          .catch((error) => {
            error.json().then((errorMessage) => {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: errorMessage.message,
                life: 3000,
              });
              console.log(errorMessage);
            });
          });
  } else {
        toast.current.show({
            severity: "warn",
            summary: "Niste izabrali kretanje za brisanje!",
            life: 3000,
            });
  }
   

  };
  const rejectDelete = () => {
    console.log("Odbijeno brisanje podataka!");
  }; 


  function toUtcIso(d) {
    if (!d) return null;
    const x = d instanceof Date ? d : new Date(d);
    const utc = new Date(x.getTime() - x.getTimezoneOffset() * 60000);
    return utc.toISOString().slice(0, 19) + 'Z';
    }

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
              // Tvrda provera redosleda datuma (handleChange više ne nuluje u toku unosa/paste-a)
              if (formDataMovement.datumOd && formDataMovement.datumDo
                  && new Date(formDataMovement.datumOd) >= new Date(formDataMovement.datumDo)) {
                  toast.current.show({ severity: "warn", summary: "Upozorenje!", detail: "Datum OD ne može biti veći od datuma DO!", life: 3000 });
                  return;
              }
      handleUploadAndSave()
   }
          const handleUploadAndSave = () => {
         
              confirmDialog({
              message: "Jel ste sigurni da želite nastaviti sa unosom?",
              acceptLabel: "Da",
              rejectLabel: "Ne",
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept: acceptInsert,
              reject: rejectInsert,
              });
          
  
      };

      const acceptInsert = async () => {

              //DATA
                  const hasAnyValueMovement = Object.values(formDataMovement).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
                  const payload = {
                        ...formDataMovement,
                        datumOd: toUtcIso(formDataMovement.datumOd),
                        datumDo: toUtcIso(formDataMovement.datumDo),
                        };

                  if(izabran && idMovement){
                 if(hasAnyValueMovement){                        
                    
                          let requestOptions = {
                            method: "POST",
                            headers: {
                            "Content-Type": "application/json",
                            Authorization: "Bearer " + auth.token,
                            },
                            body: JSON.stringify({
                                id: Number(idMovement),
                                id_putni_nalog: trip,
                                formDataMovement: payload
                            }),
                        };
                
                        await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/updateMovement", requestOptions)
                            .then(handleErrors)
                            .then((data) => {
                                
                               if(data){

                                    if(data.message){
                                        const isWarn = data.message === 'Nema izmena u podacima kretanja.'
                                            || data.message === 'Nije moguće ažuriranje. Duplikat kretanja za taj period za vozača.'
                                            || data.message === 'Nije moguće ažuriranje. Preklapanje kretanja za vozača.'
                                            || data.message === 'Nije moguće ažuriranje. Preklapanje kretanja za vozilo.';
                                        toast.current.show({
                                            severity: isWarn ? "warn" : "error",
                                            summary: isWarn ? "Upozorenje" : "Greška",
                                            detail: data.message,
                                            life: 4000,
                                        });
                                        return;
                                    }

                                toast.current.show({
                                severity: "success",
                                summary: "Uspešna izmena podataka kretanja!",
                                life: 3000,
                                });
                                setFormSubmitted(false)
                                setIdMovement(null)
                                setSelectedRowIdMovement(null)
                                resetData()
                                }

                            })
                            .catch(async (error) => {
                                let msg = 'Greška pri ažuriranju kretanja.';
                                if (error && typeof error.json === 'function') {
                                    try { const d = await error.json(); msg = d.message || msg; } catch {}
                                } else if (error?.message) {
                                    msg = error.message;
                                }
                                toast.current.show({
                                    severity: "error",
                                    summary: "Greška",
                                    detail: msg,
                                    life: 3000,
                                });
                            });
                } else {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste popunili podatke kretanja!",
                        life: 3000,
                    });
                }
           
           
            } else {
                  if(hasAnyValueMovement){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  id_putni_nalog: trip,
                                  formDataMovement: payload
                              }),
                          };
                         
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/trip/insertMovement", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                    
                                  if(data){
                                      if(data.message && (data.message == 'Nije moguć unos. Duplikat kretanja za taj period za vozača.' 
                                      || data.message == 'Nije moguć unos. Preklapanje kretanja za vozača.')){
                                      toast.current.show({
                                      severity: "warn",
                                      summary: "Upozorenje!",
                                      detail: data.message,
                                      life: 3000,
                                      });
                                      return
                                    }
                                  } 
                                  resetData()
                                  resetDataMobilisis()
                                  setFormSubmitted(false)
                                  //fillDataTableMovement()
  
                                 toast.current.show({
                                  severity: "success",
                                  summary: "Uspešan unos podataka kretanja!",
                                  life: 3000,
                                  });

                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: "Upozorenje!",
                          detail: "Niste popunili podatke kretanja za unos!",
                          life: 3000,
                      });
                  }
            }
  
    };
      const rejectInsert = () => {
      console.log("Odbijen unos podataka!");
    };     
  
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Maskirani Calendar (paste/kucanje) okida onChange sa value=null za sve nedovršene međukorake
        // (PrimeReact: nevalidan/nepotpun unos → updateModel(null)). Zato NIKAD ne nulujemo/ne prekidamo unos
        // ovde na osnovu redosleda datuma — samo uvek upišemo vrednost i preračunamo sate/dane kad su oba validna,
        // a poruku pokažemo ne-destruktivno. Tvrda provera redosleda ide na submit (handleFormSubmit / Mobilisis).
        const asDate = (v) => (v instanceof Date && !isNaN(v.getTime())) ? v : null;
        const to2 = (n) => Math.round(n * 100) / 100;

        if (name in formDataMovement) {
            setFormDataMovement(prev => {
                const next = { ...prev, [name]: value };
                if (name === 'datumOd' || name === 'datumDo') {
                    const start = asDate(next.datumOd);
                    const end   = asDate(next.datumDo);
                    if (start && end) {
                        const diffHours = (end - start) / 36e5;
                        next.ukupnoSati = to2(diffHours);
                        next.dani       = to2(diffHours / 24);
                    } else {
                        next.ukupnoSati = null;
                        next.dani = null;
                    }
                }
                return next;
            });
            if (name === 'datumOd' || name === 'datumDo') {
                const od  = asDate(name === 'datumOd' ? value : formDataMovement.datumOd);
                const doo = asDate(name === 'datumDo' ? value : formDataMovement.datumDo);
                setPorukeTimeRange2(od && doo && od >= doo ? 'Datum OD ne može biti veći od datuma DO!' : null);
            }
        }
        if (name in formDataMobilisis) {
            setFormDataMobilisis(prev => ({ ...prev, [name]: value }));
            if (name === 'datum_od' || name === 'datum_do') {
                const od  = asDate(name === 'datum_od' ? value : formDataMobilisis.datum_od);
                const doo = asDate(name === 'datum_do' ? value : formDataMobilisis.datum_do);
                setPorukeTimeRange(od && doo && od >= doo ? 'Datum OD ne može biti veći od datuma DO!' : null);
            }
        }
    };
  

  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };


  const exportExcel = async () => {
      if (!selectedColumns || selectedColumns.length === 0) return;
  
      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet('Kretanja');
  
      // Use selectedColumns instead of all table keys
      const headers = selectedColumns;
  
      // Add header row
      const headerRow = worksheet.addRow(headers);
      headerRow.font = { bold: true };
      headerRow.eachCell((cell) => {
          cell.fill = {
              type: 'pattern',
              pattern: 'solid',
              fgColor: { argb: 'FFEFEFEF' }
          };
          cell.border = {
              top: { style: 'medium' },
              left: { style: 'medium' },
              bottom: { style: 'medium' },
              right: { style: 'medium' }
          };
      });
  
      // Add filtered data rows
      tableData.forEach((rowData) => {
          const row = worksheet.addRow(headers.map(h => rowData[h] ?? ""));
          row.eachCell((cell) => {
              cell.border = {
                  top: { style: 'thin' },
                  left: { style: 'thin' },
                  bottom: { style: 'thin' },
                  right: { style: 'thin' }
              };
          });
      });
  
      // Auto-size columns
      worksheet.columns.forEach((column, i) => {
          const lengths = [
              headers[i].length,
              ...tableData.map(row => (row[headers[i]] ?? "").toString().length)
          ];
          column.width = Math.max(...lengths) + 2;
      });
  
      // Serbian-formatted datetime
      const date = new Date();
      const options = {
          day: '2-digit',
          month: '2-digit',
          year: 'numeric',
          hour: '2-digit',
          minute: '2-digit',
          timeZone: 'Europe/Belgrade'
      };
      const serbianDateTime = date.toLocaleString('sr-RS', options)
          .replace(/\s/g, ' ')
          .replace(/,/g, '');
  
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      saveAs(blob, `Kretanja - ${company.companyName} - ${serbianDateTime}.xlsx`);
  };
       const header = (
          <div className="export-buttons fakture-stavke-header">
              <div className="fakture-stavke-radnje">
                  <Button type="button" icon="pi pi-file-excel" severity="success" rounded onClick={exportExcel} data-pr-tooltip="XLS" />
                  {selectedRowIdMovement && <Button type="button" icon="pi pi-trash" severity="danger" rounded onClick={handleDeleteFuncMovement} data-pr-tooltip="Obriši" />}
              </div>
              <input
                  type="search"
                  onInput={(e) => setGlobalFilter(e.target.value)}
                  placeholder={t('nova.phPretraga')}
                  className="p-inputtext p-component"
                  style={{ width: '30%' }}
              />
          </div>
      );

  const isButtonColumn = (field) => {
    return field.startsWith('Izaberi') || 
           field.includes('File') || 
           field.includes('fajl') || 
           field.includes('upload') ||
           field.endsWith('LK') || // Lična karta
           field.endsWith('VD') || // Vozačka dozvola
           field.endsWith('PASS') || // Pasoš
           field.endsWith('VIZA') || // Viza
           field.includes('Dokument'); // Generic document
  };

    const chooseMovement = (rowData) => {
      const id = getIdMovement(rowData);

    setSelectedRowIdMovement((prev) => {
      const next = String(prev) === String(id) ? null : String(id);

    if(next) {
      setIzabran(true)
      setIdMovement(next)
      popuniRedove(id) 
      }
      else {
      setIzabran(false)
      setIdMovement(null)
      resetData()
      }

    return next;
  });
 
  
}

     const previewBodyTemplateMovement = (rowData, field) => {
      const filePathsString = rowData[field];
      if (!filePathsString) return '-';
     
      return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
              <Button
                label='Izaberi'
                icon="pi pi-eye"
                type="button"
                className="p-button-text p-button-sm"
                onClick={(e) => chooseMovement(rowData)}
              />
            
        </div>
      );
    };


  const invalidControlMovement = (data) => {
    if (!formSubmittedMovement) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

 const handleFormSubmitMovement = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmittedMovement(true)
              if (formRefMovement.current && !formRefMovement.current.checkValidity()) {
                  formRefMovement.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleGetMobilisisMovement()
   }

const handleGetMobilisisMovement = async () => {
      setFormSubmittedMovement(true)
                  // Tvrda provera redosleda datuma (handleChange više ne nuluje u toku unosa/paste-a)
                  if (formDataMobilisis.datum_od && formDataMobilisis.datum_do
                      && new Date(formDataMobilisis.datum_od) >= new Date(formDataMobilisis.datum_do)) {
                      toast.current.show({ severity: "warn", summary: "Upozorenje!", detail: "Datum OD ne može biti veći od datuma DO!", life: 3000 });
                      return;
                  }
                  //DATA
                  const hasAnyValueMobilisis = Object.values(formDataMobilisis).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });

                  if(hasAnyValueMobilisis && formDataMobilisis.datum_od != null && formDataMobilisis.datum_do ) {
                                      const payload = {
                        ...formDataMobilisis,
                        datum_od: toUtcIso(formDataMobilisis.datum_od),
                        datum_do: toUtcIso(formDataMobilisis.datum_do)
                        };

                      const datum_od_date = formDataMobilisis.datum_od instanceof Date ? formDataMobilisis.datum_od : new Date(formDataMobilisis.datum_od);
                      const datum_do_date = formDataMobilisis.datum_do instanceof Date ? formDataMobilisis.datum_do : new Date(formDataMobilisis.datum_do);

                      let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  id_putni_nalog: trip,
                                  formDataMobilisis: {
                                      ...payload,
                                      datum_od_db: datum_od_date.toISOString(),
                                      datum_do_db: datum_do_date.toISOString()
                                  }
                              }),
                          };
                  
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/gps/getMovementsMobilisis", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                
                                  if(data.Message){
                                      toast.current.show({
                                      severity: "warn",
                                      summary: "Upozorenje!",
                                      detail: data.Message,
                                      life: 3000,
                                      });
                                      return
                                  } 
                            
                                  setFormSubmittedMovement(false)
  
                                    const tipVoznje = data[0].type === 'domace' ? 'domaće vožnje' : 'međunarodne vožnje';
                               toast.current.show({
                                  severity: "success",
                                  summary: "Uspešno!",
                                  detail: `Mobilisis ${tipVoznje} — Ubačeno: ${data[0].inserted}, Preskočeno: ${data[0].skipped}, od Ukupnih: ${data[0].total}!`,
                                  life: 4000,
                                  });
                                
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                            })

                  } else {
                        toast.current.show({
                        severity: "warn",
                        summary: "Upozorenje!",
                        detail: "Niste popunili podatke za povlačenje kretanja!",
                        life: 3000,
                    });
                }

}

    return(
        <div className="retanjeVozila_ture">
            <Toast ref={toast} />
               <div className="col-12" style={{display:'flex',alignItems: "center", paddingLeft: '2%',width: '100%'}}>
                                <div style={{width: '100%', margin: '2%'}}>
                                    {trip ? <div style={{display:'flex',alignItems: "center",margin:'1% !important'}}>
                                        <h4>{t('ture.povuciKretanja')}:</h4>
                                        <form autoComplete="off" ref={formRefMovement} style={{display: 'flex', position: 'relative'}}>
                                              <Dropdown placeholder={t('nova.vozilo')} 
                                                          style={{marginLeft:'2%'}}
                                                          id="id_vozilo" 
                                                          name="id_vozilo" 
                                                          required
                                                          invalid={invalidControlMovement(formDataMobilisis.id_vozilo)} 
                                                          value={formDataMobilisis.id_vozilo} 
                                                          options={vozilaNaTuriDB || []} 
                                                          onChange={handleChange} />
                                            <Dropdown   placeholder={t('ture.vozac')}
                                                        id="id_zaposleni" 
                                                        name="id_zaposleni" 
                                                        style={{marginLeft:'2%'}}
                                                        required
                                                        invalid={invalidControl(formDataMobilisis.id_zaposleni)}
                                                        value={formDataMobilisis.id_zaposleni} 
                                                        options={vozaciNaTuriDB || []} 
                                                        onChange={handleChange} />
                                                <Calendar 
                                                            id="datum_od"
                                                            name="datum_od"
                                                            required
                                                            style={{marginLeft:'2%', maxWidth:'20%', minWidth: '170px'}}
                                                            invalid={invalidControlMovement(formDataMobilisis.datum_od)} 
                                                            value={formDataMobilisis.datum_od} 
                                                            onChange={handleChange}
                                                            showIcon 
                                                            dateFormat="dd.mm.yy"
                                                            mask="99.99.9999 99:99"
                                                            showTime 
                                                            hourFormat="24"
                                                            />
                                              <Calendar 
                                                            id="datum_do"
                                                            name="datum_do"
                                                            style={{marginLeft:'2%', maxWidth:'20%', minWidth: '170px'}}
                                                            required
                                                            invalid={invalidControlMovement(formDataMobilisis.datum_do)} 
                                                            value={formDataMobilisis.datum_do} 
                                                            onChange={handleChange}
                                                            showIcon 
                                                            mask="99.99.9999 99:99"
                                                            dateFormat="dd.mm.yy"
                                                            showTime 
                                                            hourFormat="24"
                                                            />
                 
                                                {porukaTimeRange && <p class="infoPoruka" style={{fontSize: "10px", position:'absolute',bottom: '-25px', marginBottom:'0', marginLeft:'2%'}}>{porukaTimeRange}</p>}
                      
                                        <Button label={t('ture.povuciKretanja')} type="submit" severity="secondary" className="mt-3 zaposleniShift" style={{width: 'max-content', minWidth:'150px'}} onClick={handleFormSubmitMovement} />
                                        </form>  
                                    </div> : <p class="infoPoruka" style={{margin: '0'}}>Izaberite putni nalog kako bi povukli kretanja za izabrano vozilo.</p> }  
                                          
                                </div>
                        </div>
            <div className='col-12'>
                           <form autoComplete="off" ref={formRef} style={{marginTop:'1%'}}>
                                      <div className='blagajnaDashboard' style={{display:'flex', gap:'1rem', alignItems:'flex-start', flexWrap:'wrap'}}>
                                         <div style={{flex:'1 1 35%', minWidth:'280px'}}>
                                         <Card>
                                        <div className="gridLicni kretanja" style={{gap:'5%'}}>
                                            <div className="col-12 md:col-6 kretanja_inputi" style={{display: 'flex', flexDirection:'column'}}>
                                                <label htmlFor="id_vozilo">{t('nova.vozilo')}:</label>
                                                    <CustomDropdown 
                                                        id="id_vozilo" 
                                                        name="id_vozilo" 
                                                        required
                                                        invalid={invalidControl(formDataMovement.id_vozilo)}
                                                        value={formDataMovement.id_vozilo} 
                                                        options={vozilaNaTuriDB || []} 
                                                        optionLabel="label"
                                                        onChange={handleChange}
                                                        placeholder={t('nova.phVozilo')}
                                                        />
                                            </div>
                                            <div className="col-12 md:col-6 kretanja_inputi" style={{display: 'flex', flexDirection:'column'}}>
                                                <label htmlFor="id_zaposleni">{t('ture.vozac')}:</label>
                                                    <CustomDropdown 
                                                        id="id_zaposleni" 
                                                        name="id_zaposleni" 
                                                        required
                                                        invalid={invalidControl(formDataMovement.id_zaposleni)}
                                                        value={formDataMovement.id_zaposleni} 
                                                        options={vozaciNaTuriDB || []} 
                                                        optionLabel="label"
                                                        onChange={handleChange}
                                                        placeholder={t('ture.phVozaca')}
                                                        />
                                            </div>
                                          <div className="col-12 md:col-6 kretanja_inputi" style={{display: 'flex', flexDirection:'column'}}>
                                            <label htmlFor="datumOd">{t('ture.datumOd')}:</label>
                                                        <Calendar 
                                                            id="datumOd"
                                                            name="datumOd"
                                                            required
                                                            invalid={invalidControl(formDataMovement.datumOd)} 
                                                            value={formDataMovement.datumOd} 
                                                            onChange={handleChange}
                                                            showIcon 
                                                            dateFormat="dd.mm.yy"
                                                            mask="99.99.9999 99:99"
                                                            showTime 
                                                            hourFormat="24"
                                                            />
                                          </div>
                                          <div className="col-12 md:col-6 kretanja_inputi" style={{display: 'flex', flexDirection:'column'}}>
                                            <label htmlFor="datumDo">{t('ture.datumDo')}:</label>
                                                        <Calendar 
                                                            id="datumDo"
                                                            name="datumDo"
                                                            required
                                                            invalid={invalidControl(formDataMovement.datumDo)} 
                                                            value={formDataMovement.datumDo} 
                                                            onChange={handleChange}
                                                            showIcon 
                                                            mask="99.99.9999 99:99"
                                                            dateFormat="dd.mm.yy"
                                                            showTime 
                                                            hourFormat="24"
                                                            />
                                            {porukaTimeRange2 && <p class="infoPoruka" style={{fontSize: "10px"}}>{porukaTimeRange2}</p>}
                                          </div>
                                          <div className="col-12 md:col-6 kretanja_inputi" style={{display: 'flex', flexDirection:'column'}}>
                                                <label htmlFor="id_zemlja">Zemlja:</label>
                                                    <CustomDropdown 
                                                        id="id_zemlja" 
                                                        name="id_zemlja" 
                                                        required
                                                        invalid={invalidControl(formDataMovement.id_zemlja)}
                                                        value={formDataMovement.id_zemlja} 
                                                        options={zemljeDB || []} 
                                                        optionLabel="label"
                                                        onChange={handleChange}
                                                        placeholder={t('ture.phZemlju')}
                                                        />
                                            </div>
                                          <div className="col-12 md:col-6 kretanja_inputi" style={{display: 'flex', flexDirection:'column'}}>
                                            <label htmlFor="ukupnoSati">{t('ture.ukupnoSati')}:</label>
                                             <InputNumber
                                                    id="ukupnoSati"
                                                    name="ukupnoSati"
                                                    required
                                                    style={{width:'100%'}}
                                                    invalid={invalidControl(formDataMovement.ukupnoSati)}
                                                    value={formDataMovement.ukupnoSati}
                                                    onValueChange={handleChange}
                                                    minFractionDigits={2}
                                                    maxFractionDigits={2}
                                                    />
                                          </div>
                                          <div className="col-12 md:col-6 kretanja_inputi" style={{display:'flex', flexDirection:'column'}}>
                                            <label htmlFor="dani">{t('ture.ukupnoDana')}:</label>
                                            <InputNumber
                                                id="dani" disabled
                                                name="dani" value={formDataMovement.dani} minFractionDigits={2}
                                                    maxFractionDigits={2} style={{width:'100%'}} inputStyle={{backgroundColor: '#efefef'}}
                                                />
                                        </div>
                                          <div className="col-12 md:col-6 kretanja_inputi" style={{display:'flex', flexDirection:'column'}}>
                                            <label htmlFor="napomena">{t('nova.napomena')}:</label>
                                            <InputText
                                                id="napomena"
                                                name="napomena" value={formDataMovement.napomena} onChange={handleChange}
                                                style={{width:'100%'}}
                                                />
                                        </div>
                                    </div>
                                </Card>
                                         <div className="formUnosZap buttonUnosZap">
                                           <button type="submit" onClick={handleFormSubmit} className="btn btn-success" style={{whiteSpace:'nowrap', width:'fit-content'}}>
                                             {idMovement ? "SAČUVAJ" : "UNOS"}
                                           </button>
                                         </div>
                                         </div>
                                         <div style={{flex:'2 1 55%', minWidth:'300px'}}>
                                      <Card>
                                           <Tooltip target=".export-buttons>button" position="bottom" />
                                               <DataTable
                                                      value={tableData || []}
                                                      paginator
                                                      rows={10}
                                                      first={first}
                                                      globalFilter={globalFilter}
                                                      onPage={(e) => setFirst(e.first)}
                                                      scrollable
                                                      header={header}
                                                      scrollHeight="30vh"
                                                      emptyMessage={t('common.noDataTable')}
                                                      resizableColumns
                                                      className="turePregledTable stavke-tabela"
                                                      columnResizeMode="expand"
                                                      rowClassName={(data) => (isSelected(data) ? "selected-row" : "")}
                                                    >
                                                      {selectedColumns.map((colKey) => {
                                                      const colMeta = allColumns.find(col => col.value === colKey);
                                                      return (
                                                        <Column
                                                          key={colKey}
                                                          field={colKey}
                                                          header={colMeta?.label || colKey}
                                                          sortable
                                                          body={(rowData) => {
                                                            if (isButtonColumn(colKey)) {
                                                              return previewBodyTemplateMovement(rowData, colKey);
                                                            }
                                                            return rowData[colKey] || '-';
                                                          }}
                                                          style={{ minWidth: '150px'}}
                                                        />
                                                      );
                                                    })}
                                                </DataTable>
                                      </Card>
                                         </div>
                                      </div>
                              </form>
                        </div>
        </div>
        
    )
}
export default KretanjeVozila;